// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__interLocal_53be4a', '__interLocal_Fallback_53be4a'"},"className":"__className_53be4a","variable":"__variable_53be4a"};